/* @Author: 李文 
 * @Last Modified by:   李文  */
import React from 'react';
import { message, Radio } from 'antd';
import ReactEcharts from "echarts-for-react";
import echarts from "echarts/lib/echarts";
import * as Actions from '../../../actions/bussinessStatistics';
import './storyStatistics.scss' 


class StoryStatistics extends React.Component{
    constructor(props){
        super(props);
        this.state={
            activeKey: 'month',
            total: [],
            monthxAxisData: [],
            yearxAxisData: [],
            monthyAxisData: {},
            yearyAxisData: {}
        }
    }

    componentDidMount(){
       
       this.getData()
    }

    
 
    getData =  () => {
        Actions.getStoryTypeCountResult({},(res) => {
            if(!res || !res.value){
				message.error("未获取到统计数据，请检查是否启动了统计微服务。");
				return;
            } 
            let total = [{currentY:res.value.interviewStroy.yearData[res.value.interviewStroy.yearData.length-1],allY:res.value.interviewStroy.count},{currentY:res.value.contributeStory.yearData[res.value.contributeStory.yearData.length-1],allY:res.value.contributeStory.count},{currentY:res.value.pmsStory.yearData[res.value.pmsStory.yearData.length-1],allY: res.value.pmsStory.count} ];
            let monthxAxisData = res.value.mountName;
            let yearxAxisData = res.value.yearName;
            let monthyAxisData = {};
            monthyAxisData.interviewStroy = res.value.interviewStroy.mounthData;
            monthyAxisData.contributeStory = res.value.contributeStory.mounthData;
            monthyAxisData.pmsStory = res.value.pmsStory.mounthData;
            let yearyAxisData = {};
            yearyAxisData.interviewStroy = res.value.interviewStroy.yearData;
            yearyAxisData.contributeStory = res.value.contributeStory.yearData;
            yearyAxisData.pmsStory = res.value.pmsStory.yearData;
            this.setState({
                total,
                monthxAxisData,
                yearxAxisData,
                monthyAxisData,
                yearyAxisData
            })
        })
    }

    getOptions = () => {
        const options = {
            // title: {
            //     text: '某地区蒸发量和降水量',
            //     subtext: '纯属虚构'
            // },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['原创稿件','投稿稿件','宣传部稿件'],
            },
            toolbox: {
                show: false, //工具栏
            },
            color: ['#57a9ee', '#70c781', '#fb9898'],
            xAxis: [
                {
                    name: '时间',
                    nameTextStyle: {
                        color: '#9ea5bd'
                    },
                    type: 'category',
                    data: this.state.activeKey === 'month' ? this.state.monthxAxisData : ( this.state.activeKey === 'year' ? this.state.yearxAxisData : []),
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            fontFamily: 'MicrosoftYaHei',
                            color: '#9ea5bd',
                        },
                    },
                    axisLine: {
                        show: true, //隐藏坐标轴
                        lineStyle: {
                            color: '#f4f6fc',  //坐标轴的颜色
                        },
                    },
                }
            ],
            // grid: {
            //     left: '35',
            //     right: '35',
            //     bottom: '0',
            //     top: 100,
            //     containLabel: true
            // },
            yAxis: [
                {
                    name: '单位：篇（个）',
                    nameTextStyle: {
                        color: '#9ea5bd'
                    },
                    type: 'value',
                    axisTick: { show: false },
                    // axisLabel: {
                    //     textStyle: {
                    //         fontFamily: 'MicrosoftYaHei',
                    //         color: '#9ea5bd',
                    //     },
                    // },
                    // axisLine: {
                    //     show: true, //隐藏坐标轴
                    //     lineStyle: {
                    //         color: '#f4f6fc',  //坐标轴的颜色
                    //     },
                    // },
                    splitLine: {
                        show: true,   // 网格线是否显示
                        //  改变样式
                        // lineStyle: {
                        //     color: '#f4f6fc'   // 修改网格线颜色     
                        // }
                    },
                },
            ],
            series: [
                {
                    name: '原创稿件',
                    type: 'bar',
                    data: this.state.activeKey === 'month' ?  this.state.monthyAxisData.interviewStroy : (this.state.activeKey === 'year' ?  this.state.yearyAxisData.interviewStroy : []),
                    // itemStyle: {
                    //     normal: {
                    //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //             offset: 0,
                    //             color: '#80c8ff'
                    //         }, {
                    //             offset: 1,
                    //             color: '#799aed'
                    //         }]),
                    //     }
                    // }, label: { color: '#FFBF00' }
                },
                {
                    name: '投稿稿件',
                    type: 'bar',
                    data: this.state.activeKey === 'month' ?  this.state.monthyAxisData.contributeStory : (this.state.activeKey === 'year' ?  this.state.yearyAxisData.contributeStory : []),
                    // itemStyle: {
                    //     normal: {
                    //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //             offset: 0,
                    //             color: '#aaffdb'
                    //         }, {
                    //             offset: 1,
                    //             color: '#6fe7b3'
                    //         }]),
                    //     }
                    // }, label: { color: '#00A854' }
                },
                {
                    name: '宣传部稿件',
                    type: 'bar',
                    data: this.state.activeKey === 'month' ?  this.state.monthyAxisData.pmsStory : (this.state.activeKey === 'year' ?  this.state.yearyAxisData.pmsStory : []),
                    // itemStyle: {
                    //     normal: {
                    //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //             offset: 0,
                    //             color: '#c7aaff'
                    //         }, {
                    //             offset: 1,
                    //             color: '#7c53c9'
                    //         }]),
                    //     }
                    // }
                },
            ]
        }

        return options

    }

    changeTab = (e) => {
        this.setState({
            activeKey: e.target.value,
            total:[],
            xAxisData:[],
            yAxisData:{},
        }, () => {
            this.getData()
        })
    }


    render(){
        const { activeKey,total } = this.state;
        console.log(total)
        return(
            <div className="story-statistics">
                <div className="story-statistics-left">
                    <div>
                        <span>原创稿件</span>
                        <span>{total[0]&&activeKey==='month'? total[0]&&total[0].currentY :  total[0]&&total[0].allY}</span>
                    </div>
                   <div>
                       <span>投稿稿件</span>
                       <span>{total[1]&&activeKey==='month' ? total[1]&&total[1].currentY : total[1]&&total[1].allY}</span>
                   </div>
                   <div>
                       <span>宣传部稿件</span>
                       <span>{total[2]&&activeKey==='month' ? total[2]&&total[2].currentY: total[2]&&total[2].allY}</span>
                   </div>

                </div>
                <div className="story-statistics-right">
                    <div className="story-statistics-right-options">
                    <Radio.Group value={activeKey} onChange={this.changeTab}>
                        <Radio.Button value="month">本年</Radio.Button>
                        <Radio.Button value="year">历年</Radio.Button>
                    </Radio.Group>
                    </div>
                <ReactEcharts
                            option={this.getOptions()}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{width: '100%', height: '100%'}}
                        />
                </div>
            
            </div>
        )
    }
}

export default StoryStatistics